export const NAV_HEIGHT = 70;
export const MOBILE_NAV_HEIGHT = '100vh';
export const MOBILE_NAV_TRANSITION_SPEED = '400ms';
export const MOBILE_NAV_TRANSITION_FUNCTION = 'ease-in-out';



// WEBPACK FOOTER //
// ./src/common/consts/navigation.js